export default __webpack_public_path__ + "static/media/game_2_1.992f25bb.png";